<freud-card class="address-particular-price" *ngIf="priceForm">
	<h1 class="address-particular-price__label">{{ title }}</h1>
	<div>
		<app-session-values
			class="zk-my-2 zk-block zk-w-fit-content"
			type="particular"
			[particularPrice]="price ?? 0"
		></app-session-values>
		<div
			freud-tooltip
			[tooltipLabel]="
				!canUpdatePrice && action === 'edit'
					? ('MY_ACCOUNT.PLAN_SESSION.FORM.PRICE_PER_SESSION.TOOLTIP_CANT_EDIT'
                    | translate)
					: ('MY_ACCOUNT.PLAN_SESSION.FORM.PRICE_PER_SESSION.TOOLTIP_EDIT'
                    | translate)
			"
		>
			<freud-button [disabled]="!canUpdatePrice && action === 'edit'" (click)="openPriceModal()" color="secondary">{{
				'PAGES.ADDRESS.CHANGE' | translate
			}}</freud-button>
		</div>
	</div>
</freud-card>
<address-price-modal
	[price]="price"
	[isOpen]="isPriceModalOpen"
	(onClose)="isPriceModalOpen = false"
	(onSave)="onChange.emit($event)"
></address-price-modal>
